<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">{{ dummy }}</div>
    </div>
    <div v-else class="row">
      <ListItemAccount
        v-for="clan in visibleClanList"
        :key="clan.id"
        :secondary-model="clan"
        :role="isMyAccount ? clan.role : null"
        class="col-12 mb-3"
      />
    </div>
    <div class="row">
      <div
        v-if="isMyAccount || isCollapsible"
        key="favTeamsExpandLink"
        class="col-12 d-flex justify-content-between"
      >
        <router-link
          v-if="isMyAccount"
          :to="{
            name: 'createClanDetails',
          }"
          class="font-size-sm cursor-hand text-link h-mr-4 purple"
          >{{
            $t('_web_newsfeed_clan-reminder-create-clan', 'Create Clan')
          }}</router-link
        >
        <span
          v-if="isCollapsible"
          class="font-size-sm cursor-hand text-link h-mr-4"
          @click.prevent="toggleSeeAll"
        >
          {{ seeAllText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import TextLabel from '@/components/atoms/TextLabel';
import ListItemAccount from '@/components/common/ListItemAccount';
export default {
  name: 'AccountInfoTeams',
  components: {
    TextLabel,
    ListItemAccount,
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    ...mapState('current', ['accountId', 'account']),
    ...mapState('my', { myAccountID: 'accountId' }),
    ...mapGetters('my/clans', { myClans: 'clanList' }),
    ...mapGetters('current/clans', { clans: 'clanList' }),
    label() {
      return this.$t('_web_profile-info_team-header', `Teams`, {
        name: this.account._name,
      });
    },
    isMyAccount() {
      return this.myAccountID === this.accountId;
    },
    clanList() {
      return this.isMyAccount ? this.myClans : this.clans;
    },
    visibleClanList() {
      return this.showAll ? this.clanList : this.clanList.slice(0, 3);
    },
    seeAllText() {
      return this.showAll
        ? this.$t('_web_account_favorite-games-see-all-collapse', 'Collapse')
        : this.$t('_web_account_favorite-games-see-all', 'See All');
    },
    isCollapsible() {
      return this.clanList.length > 3;
    },
    dummy() {
      return this.$lodash.isEmpty(this.clanList)
        ? this.$t('_web_profile-info_no-team', 'No Team')
        : null;
    },
  },
  methods: {
    toggleSeeAll() {
      this.showAll = !this.showAll;
    },
  },
};
</script>
<style lang="scss">
.purple {
  color: #5a58f2;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
